module.exports = __webpack_public_path__ + "img/logo-AIRLEARN.ced51b30.svg";